import { GraphQLClient } from 'graphql-request'
import { useMemo } from 'react'

import useMicroSiteStore from '@/stores/useMicroSiteStore'
import useSessionStore from '@/stores/useSessionStore'
import { brand } from '@/utils/brand'
import { getDefaultEndpoint } from '@/utils/urlHelpers'

export const useGraphQLClient = (
  customEndpoint?: string,
  customHeaders?: Record<string, string>,
): GraphQLClient => {
  const authToken = useSessionStore((store) => store.authToken)
  const microSite = useMicroSiteStore((store) => store.microSite)
  const microSiteId = useMemo(() => microSite?.id, [microSite?.id])

  const client = useMemo(() => {
    const headers: Record<string, string> = {
      Authorization: `Bearer ${authToken || ''}`,
      Accept: 'application/json',
      'x-brand-id': brand.key,
      'x-user-token': authToken || '',
      ...customHeaders,
    }

    if (microSiteId && !customEndpoint?.includes('api/v6/graphql')) {
      headers['x-micro-site-id'] = microSiteId
    }

    return new GraphQLClient(customEndpoint || getDefaultEndpoint(), {
      headers,
    })
  }, [authToken, microSiteId, customEndpoint, customHeaders])

  return client
}
